<!-- Header -->
<app-header></app-header>

<!-- Page content -->
<router-outlet></router-outlet>

<!-- Footer -->
<app-footer></app-footer>

<!-- Scroll to Top Button -->
<button
  class="scroll-to-top"
  [class.show]="showScrollTop"
  (click)="scrollToTop()"
  aria-label="Scroll to top"
  title="Scroll to top"
>
  <i class="bi bi-arrow-up"></i>
</button>